module.exports = __webpack_public_path__ + "assets/img/reminder-collate-1.086a3b2b.png";